(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-alt"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    const mainImage = document.getElementById('main-product-image');
    const thumbnails = document.querySelectorAll('.thumbnail-image');
    const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');

    // Thumbnail click
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function () {
        mainImage.src = this.dataset.mediaSrc;
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // Variant change
    variantSelectors.forEach(select => {
      select.addEventListener('change', function () {
        const selectedId = this.value;
        const selectedVariant = productData.variants.find(v => v.id == selectedId);
        const featuredImage = selectedVariant.featured_media;

        if (featuredImage) {
          mainImage.src = featuredImage.preview_image.src;
          thumbnails.forEach(t => {
            t.classList.remove('active');
            if (t.dataset.mediaId == featuredImage.id) {
              t.classList.add('active');
            }
          });
        }
      });
    });
  });
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-tab"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    const mainImage = document.getElementById('main-product-image');
    const thumbnails = document.querySelectorAll('.thumbnail-image');
    const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');

    // Thumbnail click
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function () {
        mainImage.src = this.dataset.mediaSrc;
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // Variant change
    variantSelectors.forEach(select => {
      select.addEventListener('change', function () {
        const selectedId = this.value;
        const selectedVariant = productData.variants.find(v => v.id == selectedId);
        const featuredImage = selectedVariant.featured_media;

        if (featuredImage) {
          mainImage.src = featuredImage.preview_image.src;
          thumbnails.forEach(t => {
            t.classList.remove('active');
            if (t.dataset.mediaId == featuredImage.id) {
              t.classList.add('active');
            }
          });
        }
      });
    });
  });
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    const mainImage = document.getElementById('main-product-image');
    const thumbnails = document.querySelectorAll('.thumbnail-image');
    const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');

    // Thumbnail click
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function () {
        mainImage.src = this.dataset.mediaSrc;
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // Variant change
    variantSelectors.forEach(select => {
      select.addEventListener('change', function () {
        const selectedId = this.value;
        const selectedVariant = productData.variants.find(v => v.id == selectedId);
        const featuredImage = selectedVariant.featured_media;

        if (featuredImage) {
          mainImage.src = featuredImage.preview_image.src;
          thumbnails.forEach(t => {
            t.classList.remove('active');
            if (t.dataset.mediaId == featuredImage.id) {
              t.classList.add('active');
            }
          });
        }
      });
    });
  });
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-form-offerpage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const enquireButton = document.querySelector('.scroll-to-footer-form');
    const targetForm = document.getElementById('footer-contact-form');

    if (enquireButton && targetForm) {
      enquireButton.addEventListener('click', () => {
        const offset = 220; // Push target 100px below the top of the viewport
        const formTop = targetForm.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({ top: formTop, behavior: 'smooth' });

        setTimeout(() => {
          document.querySelector('input[id="form_input_0"]').focus();
        }, 600);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const enquireButton = document.querySelector('.scroll-to-footer-form');
    const targetForm = document.getElementById('footer-contact-form');

    if (enquireButton && targetForm) {
      enquireButton.addEventListener('click', () => {
        const offset = 220; // Push target 100px below the top of the viewport
        const formTop = targetForm.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({ top: formTop, behavior: 'smooth' });

        setTimeout(() => {
          document.querySelector('input[id="form_input_0"]').focus();
        }, 600);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('scroll', () => {
    const button = document.getElementById('scrollToTop');
    if (window.scrollY > 300) {
      button.classList.remove('hidden');
    } else {
      button.classList.add('hidden');
    }
  });
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["machine-featured"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tag-filters button').forEach(button => {
    button.addEventListener('click', () => {
      const tag = button.dataset.tag;
      document.querySelectorAll('.grid__item').forEach(item => {
        const tags = item.dataset.tags;
        if (tag === '' || tags.includes(tag)) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profit-calculator"] && !Shopify.designMode) return;
  try {
    
//calculator

    $("#priceRange").on("input", function () {
        var val1 = "$" + $(this).val();
        $(".priceRangeValue").text(val1);
    });

    $("#priceRange-acai").on("input", function () {
        var val1 = "$" + $(this).val();
        $(".priceRangeValue").text(val1);
    });

    $("#servingsRange").on("input", function () {
        var val1 = $(this).val() + " servings";
        $(".servingsValue").text(val1);
    });

    $("#servingsRange-acai").on("input", function () {
        var val1 = $(this).val() + " servings";
        $(".servingsValue").text(val1);
    });

    $("#weeksRange").on("input", function () {
        var val1 = $(this).val() + " weeks";
        $(".weeksValue").text(val1);
    });

    $("#weeksRange-acai").on("input", function () {
        var val1 = $(this).val() + " weeks";
        $(".weeksValue").text(val1);
    });

    $(document).ready(function () {
        // price bg
        function updateBackground1() {
            var valueR = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueR + "%, #fff " + valueR + "%, white 100%)";
        }

        $("#priceRange,#priceRange-acai").on("input", updateBackground1);

        $("#priceRange,#priceRange-acai").each(function () {
            updateBackground1.call(this);
        });

        // servings bg
        function updateBackground2() {
            var valueR = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueR + "%, #fff " + valueR + "%, white 100%)";
        }

        $("#servingsRange,#servingsRange-acai").on("input", updateBackground2);

        $("#servingsRange,#servingsRange-acai").each(function () {
            updateBackground2.call(this);
        });

        // weeks bg
        function updateBackground3() {
            var valueR = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueR + "%, #fff " + valueR + "%, white 100%)";
        }

        $("#weeksRange,#weeksRange-acai").on("input", updateBackground3);

        $("#weeksRange,#weeksRange-acai").each(function () {
            updateBackground3.call(this);
        });
    });

    $ = jQuery;
    if ($("#priceRange").length) {
        var slider_sp = document.getElementById("priceRange");
        var output_sp = document.getElementById("sp-range");
        output_sp.innerHTML = slider_sp.value;

        slider_sp.oninput = function () {
            output_sp.innerHTML = this.value;
            $("#rag1").val(this.value);
            calculateProfit();

            var valueR = ((this.value - this.min) / (this.max - this.min)) * 100;

            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueR + "%, #fff " + valueR + "%, white 100%)";
        };
    }

    //acai range
    if ($("#priceRange-acai").length) {
        var slider_sp = document.getElementById("priceRange-acai");
        var output_sp = document.getElementById("sp-range-acai");
        output_sp.innerHTML = slider_sp.value;

        slider_sp.oninput = function () {
            output_sp.innerHTML = this.value;
            $("#rag1-acai").val(this.value);
            calculateProfitAcai();

            var valueR = ((this.value - this.min) / (this.max - this.min)) * 100;

            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueR + "%, #fff " + valueR + "%, white 100%)";
        };
    }

    if ($("#servingsRange").length) {
        var slider_ser = document.getElementById("servingsRange");
        var output_ser = document.getElementById("serve-range");
        output_ser.innerHTML = slider_ser.value;

        slider_ser.oninput = function () {
            output_ser.innerHTML = this.value;
            $("#rag2").val(this.value);
            calculateProfit();

            var valueS = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueS + "%, #fff " + valueS + "%, white 100%)";
        };
    }

    //servings acai

    if ($("#servingsRange-acai").length) {
        var slider_ser = document.getElementById("servingsRange-acai");
        var output_ser = document.getElementById("serve-range-acai");
        output_ser.innerHTML = slider_ser.value;

        slider_ser.oninput = function () {
            output_ser.innerHTML = this.value;
            $("#rag2-acai").val(this.value);
            calculateProfitAcai();

            var valueS = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueS + "%, #fff " + valueS + "%, white 100%)";
        };
    }

    if ($("#weeksRange").length) {
        var slider_w = document.getElementById("weeksRange");
        var output_w = document.getElementById("weeks-range");
        output_w.innerHTML = slider_w.value;

        slider_w.oninput = function () {
            output_w.innerHTML = this.value;
            $("#rag3").val(this.value);
            calculateProfit();
            var valueW = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueW + "%, #fff " + valueW + "%, white 100%)";
        };
    }

    // weeks acai
    if ($("#weeksRange-acai").length) {
        var slider_w = document.getElementById("weeksRange-acai");
        var output_w = document.getElementById("weeks-range-acai");
        output_w.innerHTML = slider_w.value;

        slider_w.oninput = function () {
            output_w.innerHTML = this.value;
            $("#rag3-acai").val(this.value);
            calculateProfitAcai();
            var valueW = ((this.value - this.min) / (this.max - this.min)) * 100;
            this.style.background =
                "linear-gradient(to right, #82CFD0 0%, #82CFD0 " + valueW + "%, #fff " + valueW + "%, white 100%)";
        };
    }
    function calculateProfit() {
        var sp = parseFloat($("#rag1").val());
        var serno = parseInt($("#rag2").val());
        var wkno = parseInt($("#rag3").val());
        var cp = parseFloat($("#costval").val());
        var pr_diff = sp - cp;
        // var pr_diff = Math.abs(sp - cp);

        var profit = pr_diff * (serno * wkno * 7);
        var profit_m = (pr_diff * (serno * 52 * 7)) / 12;

        $("#m-prof").html("$" + profit_m.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        $("#y-prof").html("$" + profit.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","));

        if (profit >= 100000) {
            $(".get-started__cont").addClass("small-font");
        } else {
            $(".get-started__cont").removeClass("small-font");
        }

        if (profit >= 1000000) {
            $("#y-prof").addClass("negative-margin");
        } else {
            $("#y-prof").removeClass("negative-margin");
        }
    }

    function calculateProfitAcai() {
        var sp = parseFloat($("#rag1-acai").val());
        var serno = parseInt($("#rag2-acai").val());
        var wkno = parseInt($("#rag3-acai").val());
        var cp = parseFloat($("#costval-acai").val());
        var pr_diff = sp - cp;
        // var pr_diff = Math.abs(sp - cp);

        var profit = pr_diff * (serno * wkno * 7);
        var profit_m = (pr_diff * (serno * 52 * 7)) / 12;

        $("#m-prof-acai").html("$" + profit_m.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        $("#y-prof-acai").html("$" + profit.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","));

        if (profit >= 100000) {
            $(".get-started__cont").addClass("small-font");
        } else {
            $(".get-started__cont").removeClass("small-font");
        }

        if (profit >= 1000000) {
            $("#y-prof-acai").addClass("negative-margin");
        } else {
            $("#y-prof-acai").removeClass("negative-margin");
        }
    }

    $(document).ready(function () {
        calculateProfit();
        calculateProfitAcai();
    });

  } catch(e) { console.error(e); }
})();
})();
